import styled from 'styled-components'

export const NotificationDropdownShell = styled.div`
  width: min(260px, calc(100vw - 24px));
  display: flex;
  flex-direction: column;
  color: "#1A1A1A";
  padding: 8px 0;
`

export const HelpHeaderTitle = styled.div`
  font-size: 14px;
  padding: 8px 12px;
`

export const HelpValue = styled.a`
  padding: 8px 12px;
  font-size: 12px;
  gap: 10px;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  border-radius: 8px;
  margin: 0 4px;
  transition: background 0.15s ease;

  &:hover {
    background: #f5f6f8;
  }

  &:active {
    background: #eef0f3;
  }
`
